import { useEffect, useRef, useState } from "react";
import { copyText } from "@/lib/clipboard";
import { cn } from "@/lib/utils";

interface CopyButtonProps {
  text: string;
  className?: string;
  copiedLabel?: string;
  idleLabel?: string;
  ariaLabel?: string;
  duration?: number;
  onClick?: () => void;
}

// 复用旧 install-card / cta-install 的复制反馈：
// click → navigator.clipboard.writeText → 加 .copied class 1.8s → 还原
// 文案在 .copied 时切换。idleLabel/copiedLabel 默认匹配 install-copy 按钮。
export function CopyButton({
  text,
  className,
  copiedLabel = "已复制",
  idleLabel = "复制",
  ariaLabel = "复制命令",
  duration = 1800,
  onClick,
}: CopyButtonProps) {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<number | undefined>(undefined);

  useEffect(() => () => {
    if (timerRef.current) window.clearTimeout(timerRef.current);
  }, []);

  const handleClick = async () => {
    onClick?.();
    await copyText(text);
    setCopied(true);
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => setCopied(false), duration);
  };

  return (
    <button
      type="button"
      className={cn(className, copied && "copied")}
      aria-label={ariaLabel}
      onClick={handleClick}
    >
      {copied ? copiedLabel : idleLabel}
    </button>
  );
}
